import { FC } from "react";
import { HelpCircle } from "../icons";
import { T } from "@tolgee/react";

export const CheckCrpQuantitiesTitle: FC = () => {
  return (
    <div className="flex items-center gap-2.5 text-base font-medium text-mandarin-900">
      <HelpCircle className="text-mandarin-600" size={20} />
      <T keyName="check-crp-quantities-dialog-title" />
    </div>
  );
};
